<template>
  <div v-if="currentPlan" class="block md:grid gap-x-lg grid-cols-page mb-4 mb-base">
    <h3 id="current-plan-title" class="mb-none col-span-full">{{ $t('companySettings.billing.currentPlanSection.title') }}</h3>
    <hr class="my-sm col-span-full" />
    <p id="current-plan-info" class="col-span-1 mb-base">{{ $t('companySettings.billing.currentPlanSection.info') }}</p>
    <div class="col-span-1 block">
      <!--     Usage Chart-->
      <b id="current-plan-usage-subtitle" v-if="currentPlan.id !== 'pay-as-you-go'" class="col-span-1 block mb-base">{{ $t('companySettings.billing.currentPlanSection.currentUsage') }}</b>
      <div class="md:w-1/2 w-2/3" id="current-plan-usage-chart" v-if="currentPlan.id !== 'pay-as-you-go'">
        <VUsageDisplayChart
            :usage="usage.usage"
            :allowance="usage.plan.allowance" />
      </div>
<!--      PLan Name-->
      <b>{{ $t('companySettings.billing.currentPlanSection.planName') }}</b>
      <p id="current-plan-name">{{ currentPlan.nickname }}</p>
<!--      Usage: Subscription-->
      <div class="mb-base" v-if="currentPlan.id !== 'pay-as-you-go'">
        <b id="current-plan-allowance-subtitle" >{{ $t('companySettings.billing.currentPlanSection.envelopeAllowance') }}</b>
        <p id="current-plan-allowance" >{{ currentPlan.allowance }}</p>
      </div>
<!--      Usage: Payg-->
      <div class="mb-base" v-else>
        <b id="current-plan-credits-subtitle">{{ (usage.credits === 1 ? $tc('companySettings.billing.currentPlanSection.creditsRemaining',1) : $tc('companySettings.billing.currentPlanSection.creditsRemaining',2)) }}</b>
        <p id="current-plan-credits">{{ usage.credits }}</p>
      </div>
<!--      Plan Price-->
      <b>{{ $t('companySettings.billing.currentPlanSection.price') }}</b>
      <p id="current-plan-price">{{ price }}</p>
<!--      Plan Features-->
      <b id="current-plan-features-subtitle">{{ $t('companySettings.billing.currentPlanSection.planFeatures') }}</b>
      <p>
        <span :id="`current-plan-features-${feature}`" v-for="feature in currentPlan.scope" :key="feature">
          {{ $t(`companySettings.billing.plan.features.${feature}`) }},
        </span>
        <span id="current-plan-features-templates">{{ $t('companySettings.billing.plan.features.templates') }}</span>
      </p>
<!--      Plan Status-->
      <div id="current-plan-status-section" v-if="usage.switching_to_plan">
        <b id="current-plan-status-subtitle">{{ $t('companySettings.billing.currentPlanSection.planStatus') }}</b>
        <i18n path="companySettings.billing.switchingToPlan" tag="p">
          <template v-slot:planName>
            <span id="current-plan-future-plan">{{ usage.switching_to_plan.nickname }}</span>
          </template>
          <template v-slot:startDate>
            <b id="current-plan-switch-timeframe">{{ usage.allowance_period.end | formatDate('days') }}</b>
          </template>
        </i18n>
        <p id="current-plan-upgrade-text">{{ $t('companySettings.billing.alternativelyUpgrade') }}</p>
      </div>
<!--      Add Credits Button-->
      <VButton
          v-if="currentPlan.id === 'pay-as-you-go'"
          type="outline-1"
          @click.native="checkDDThenAddCredits()"
          data-ec="billing_current_plan"
          href="#"
          data-et="add_credits_button">
        {{ $t('companySettings.billing.addCredits') }}
      </VButton>
    </div>
    <AddCreditsModal :show="showCreditsModal" @close="showCreditsModal = false;" />
    <AddCreditsDirectDebitBlockModal :show="showDDBlockModal" @close="showDDBlockModal = false;" />
  </div>
</template>

<script>

import VUsageDisplayChart from '@/views/components/UsageDisplayChart.vue';
import VButton from '@/components/deprecated/atoms/Button.vue';
import AddCreditsModal from '@/views/modals/payment/AddCreditsModal.vue';
import AddCreditsDirectDebitBlockModal from '@/views/modals/payment/AddCreditsDirectDebitBlockModal.vue';

export default {
  name: 'BillingCurrentPlan',
  components: {
    VUsageDisplayChart,
    VButton,
    AddCreditsModal,
    AddCreditsDirectDebitBlockModal,
  },
  data() {
    return {
      showCreditsModal: false,
      showDDBlockModal: false,
    };
  },
  props: {
    currentPlan: Object,
    usage: Object,
    paygPrice: String,
    paymentMethods: Array,
  },
  computed: {
    price() {
     return this.currentPlan.id === 'pay-as-you-go' ? this.paygPrice : this.subscriptionPrice;
    },
    subscriptionPrice() {
      const priceAsDecimal = this.currentPlan.price / 100;
      return this.$n(parseFloat(priceAsDecimal), 'currency', this.currentPlan.currency);
    },
  },
  methods: {
    checkDDThenAddCredits() {
      if (this.paymentMethods.length) {
        const defaultMethod = this.paymentMethods.find(method => method.is_default === true);
        if (defaultMethod.type === 'Source') {
          this.showDDBlockModal = true;
        } else {
          this.showCreditsModal = true;
        }
      } else {
        this.showCreditsModal = true;
      }
    },
  },
};
</script>
